import {Component} from 'lowkey-component'
import {HoverImages} from '@components/helpers/HoverImages'

export class ServiceItemsDesktop extends Component<HTMLDivElement> {

  private imageContainer: HTMLDivElement | undefined = undefined
  private hoverImages: HoverImages | null = null
  private images: HTMLDivElement[] = []
  private items: HTMLDivElement[] = []

  constructor(element: HTMLDivElement) {
    super(element)
    this.onMouseEnterServiceItem = this.onMouseEnterServiceItem.bind(this)
    this.onMouseLeaveServiceItem = this.onMouseLeaveServiceItem.bind(this)
  }

  didMount() {

    this.imageContainer = document.querySelector('.s-service_images') as HTMLDivElement

    if (this.imageContainer) {
      this.images = [...this.imageContainer.querySelectorAll('.s-service_image')] as HTMLDivElement[]
    }

    this.items = [...this.element.querySelectorAll('.m-service-section-item')] as HTMLDivElement[]

    this.items.map(item => {
      item.addEventListener('mouseenter', this.onMouseEnterServiceItem)
      item.addEventListener('mouseleave', this.onMouseLeaveServiceItem)
    })

    this.hoverImages = new HoverImages(
      this.element,
      this.imageContainer,
      this.images,
      this.items,
      5
    )
    this.hoverImages.init()
  }

  didUnmount() {
    this.hoverImages?.destroy()
    this.items.map(item => {
      item.removeEventListener('mouseenter', this.onMouseEnterServiceItem)
      item.removeEventListener('mouseleave', this.onMouseLeaveServiceItem)
    })
  }

  onMouseEnterServiceItem(e: MouseEvent) {
    const target = e.target as HTMLDivElement
    target.classList.add('active')
  }

  onMouseLeaveServiceItem(e: MouseEvent) {
    const target = e.target as HTMLDivElement
    target.classList.remove('active')
  }

}
